import ActiveValue from '~types/ActiveValue';
import { valueStatementMapFP } from '../../constants/valueStatementsFP';

export const getValueStatementDisplayOrder = (value: ActiveValue): number => {
  if (!value || !Number.isInteger(value.statementId) || value.statementId < 0) {
    return 0;
  }
  const statmentId = valueStatementMapFP.get(value.statementId)?.displayOrdinal;
  return !statmentId ? 0 : statmentId;
};

export const sortValueList = (
  valueList: Array<ActiveValue>
): Array<ActiveValue> => {
  if (!valueList) {
    return [];
  }
  return valueList.sort((value1, value2) => {
    return (
      getValueStatementDisplayOrder(value1) -
      getValueStatementDisplayOrder(value2)
    );
  });
};
